import React, { useState } from 'react';
import { Row, Drawer, Image, Button } from 'antd';
import { MEDIA_WIDTHS } from '../../theme/Theme';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { styled } from 'styled-components';
import { MenuOutlined } from '@ant-design/icons';
import ButtonConnectWallet from './components/ButtonConnectWallet';
import DropdownNetwork from './components/DropdownNetwork';
import Twitter from '../../assets/landing/twitter.svg';
import Telegram from '../../assets/landing/telegram.svg';
import Discord from '../../assets/landing/discord.svg';

const Wrapper = styled.div`
    width: 100%;
    .header-body {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        max-width: 1440px;
        margin: 0 auto;
        height: 90px;
    }
    .logo {
        width: auto;
        padding: 0 22px;
        height: 40px;
        color: white;
        background: transparent;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Joystix';
        font-style: normal;
        font-weight: 400;
        font-size: 22px;
        line-height: 34px;
        color: #ea34b0;
        text-decoration: none;
    }
    .right-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        margin-right: 22px;
        .whitepaper {
            width: auto;
            padding: 0 40px;
            height: 40px;
            color: white;
            background: black;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .connect-wallet-button {
            display: flex;
            flex-direction: row;
        }
    }
    .box-menu {
        height: 50%;
        .menu-item {
            padding: 0 16px;
            height: 100%;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 20px;
            color: #666666;
            display: flex;
            align-items: center;
            justify-content: center;
            text-align: center;
        }
    }

    .drawer-icon {
        margin-left: 16px;
        padding: 12px;
        border: 0.5px solid white;
        border-radius: 8px;
        background: black;
        color: white;
        display: none;
    }

    @media screen and (max-width: ${MEDIA_WIDTHS.upToMedium}px) {
        .drawer-icon {
            display: block;
        }
        .box-menu {
            display: none;
        }
        .header-body {
            .right-box {
                .connect-wallet-button {
                    display: none;
                }
            }
        }
    }
`;

const menuData = [
    {
        title: 'Collections',
        link: '/gallery',
    },
    {
        title: 'How To Buy',
        link: '#how-to-buy',
    },
    {
        title: 'About',
        link: '#about-us',
    },
    {
        title: 'Roadmap',
        link: '#roadmap',
    },
    // {
    //     title: 'Tokenomics',
    //     link: '#Tokenomics',
    // },
    // {
    //     title: 'Dao',
    //     link: '#dao',
    // },
    // {
    //     title: 'FAQ',
    //     link: '#faq',
    // },
];

const DrawerMenuItem = styled.div`
    padding: 12px 0;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.3);
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #666666;
    &:hover {
        cursor: pointer;
    }
`;

const SocialBox = styled.div`
    width: 46px;
    height: 46px;
    border: 1px solid #ea34b0;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
        cursor: pointer;
    }
`;

const SpaceWidth = styled.div`
    width: 12px;
`;

const Header = () => {
    const [openDrawer, setOpenDrawer] = useState(false);
    const [selectedLink, setSelectedLink] = useState('');
    const location = useLocation();
    const navigate = useNavigate();

    const showDrawer = () => {
        setSelectedLink('');
        setOpenDrawer(true);
    };
    const onClose = () => {
        setOpenDrawer(false);
    };

    const onItemClicked = (selected: string) => {
        setSelectedLink(selected);
        onClose();
    };

    const afterOpenChange = () => {
        if (selectedLink.length <= 0) {
            return;
        }
        if (selectedLink.includes('#')) {
            if (location.pathname.length > 1) {
                navigate(`/${selectedLink}`);
                return;
            }
            window.location.hash = selectedLink;
            return;
        }
        navigate(selectedLink);
    };
    const navigateTo = (link: string): string => {
        if (location.pathname.length > 1 && link.includes('#')) {
            return `/${link}`;
        }
        return link;
    };
    return (
        <Wrapper>
            <div className="header-body">
                <NavLink key={'home'} to={'/'} className="logo">
                    Bpunks
                </NavLink>
                <Row className="box-menu">
                    {menuData.map((item) => (
                        <NavLink key={item.link} to={navigateTo(item.link)} className="menu-item">
                            {item.title}
                        </NavLink>
                    ))}
                </Row>
                <div className="right-box">
                    <SocialBox onClick={() => window.open('https://twitter.com/bpunksofficial', '_blank')}>
                        <Image preview={false} src={Twitter} />
                    </SocialBox>
                    <SpaceWidth />
                    <SocialBox onClick={() => window.open('https://discord.gg/raSSjJwVT3', '_blank')}>
                        <Image preview={false} src={Discord} />
                    </SocialBox>
                    <SpaceWidth />
                    <div className="connect-wallet-button">
                        <ButtonConnectWallet />
                        <DropdownNetwork />
                    </div>
                    <MenuOutlined className="drawer-icon" onClick={showDrawer} />
                </div>
            </div>
            <Drawer
                placement="right"
                width="100%"
                open={openDrawer}
                onClose={onClose}
                afterOpenChange={afterOpenChange}
                autoFocus={false}
                closable
            >
                {menuData.map((item) => (
                    <DrawerMenuItem key={item.link} autoFocus={false} onClick={() => onItemClicked(item.link)}>
                        {item.title}
                    </DrawerMenuItem>
                ))}
            </Drawer>
        </Wrapper>
    );
};

export default Header;
